import type { HeadCell } from "./types";

export const COLUMN_COUNT = 10;
export const ROW_NUMBER_WIDTH_PCT = 3;

export const HEAD_CELLS: HeadCell[] = [
  { id: "caseName", label: "Case Name", widthPct: 12 },
  { id: "taskName", label: "Task", widthPct: 11 },
  { id: "practiceArea", label: "Practice Area", widthPct: 6 },
  { id: "createdAt", label: "Created At", widthPct: 8 },
  { id: "dueDate", label: "Due Date", widthPct: 7 },
  { id: "caseTeam", label: "Case Team", widthPct: 12 },
  { id: "status", label: "Status", widthPct: 12 },
  { id: "statusHistory", label: "Status History", widthPct: 14 },
  { id: "note", label: "Note", widthPct: 15 },
];

export {
  TABLE_HEADER_CELL_SX,
  TABLE_BODY_CELL_SX,
} from "../../../components/ui";

export const STATUS_ATTENTION_DAYS = 2;
export const ATTENTION_ROW_BG = "rgba(254, 226, 226, 0.55)";
export const ATTENTION_ROW_HOVER_BG = "rgba(254, 202, 202, 0.7)";
export const OVERDUE_ROW_BG = "rgba(254, 226, 226, 0.35)";
